import { SettingsPageFrame } from '@eluve/blocks';
import { useTranslation } from '@eluve/i18n';

import { TenantUserSnippetsList } from '../../TenantUserSnippetsList';

export const ShortcutsSettingsPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <SettingsPageFrame title={t('settings.nav.shortcuts')}>
      <TenantUserSnippetsList />
    </SettingsPageFrame>
  );
};
